import styled from '@emotion/styled';
import theme from '../../theme';

export const Container = styled.div({
  borderBottom: `3px solid ${theme.colors.dark}`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '0.625rem',
});

export const Headline = styled.h3({
  margin: 0,
  paddingBottom: '0.625rem',
  fontFamily: 'inherit',
  fontWeight: 'bold',
  fontSize: '1.5rem',
  lineHeight: '1.8rem',
  color: theme.colors.dark,

  '&.--no-desktop': {
    [`@media ${theme.breakpoints.above.small}`]: {
      visibility: 'hidden',
    },
  },
});

export const Note = styled.div({
  marginTop: 'auto',
  paddingBottom: '0.625rem',
  paddingLeft: '1rem',
  fontSize: '0.865rem',
  lineHeight: '1.25rem',
  textAlign: 'right',
  color: theme.colors.grey,
});
